import type { SportType, WorkoutSegment } from '@/types';
import { generateFitFile, normalizeFitWorkoutFileBasename } from './fitEncoder';

/**
 * FIT workout encoding uses the in-repo Garmin-compatible binary writer (`fitEncoder.ts`).
 * This avoids an extra dependency; npm stacks like `fit-file-factory` / `@garmin-fit/sdk` would duplicate the same concern.
 */

/** Input for a downloadable cycling/running workout FIT (sport selects Garmin workout sport). */
export interface FitWorkoutData {
  workoutName: string;
  segments: WorkoutSegment[];
  sport: SportType;
}

/**
 * Build a binary Garmin/Wahoo-compatible workout `.fit` blob.
 * Cycling segments use `powerLow` / `powerHigh` as fractions of FTP; `userFtp` converts them to watts.
 */
export function generateFitWorkout(workoutData: FitWorkoutData, userFtp: number): Blob {
  const bytes = generateFitFile(workoutData.segments, workoutData.workoutName, workoutData.sport, {
    ftpWatts: userFtp,
  });
  return new Blob([bytes], { type: 'application/octet-stream' });
}

export function getNormalizedFitDownloadFilename(workoutName: string): string {
  return `${normalizeFitWorkoutFileBasename(workoutName)}.fit`;
}
